"use client";

import { useMemo } from "react";
import { Globe, Check } from "lucide-react";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { usePathname, useRouter } from "next/navigation";

type Language = "zh" | "en" | "ja";

export function LanguageToggle() {
  const pathname = usePathname() ?? "/";
  const router = useRouter();

  const supported: Language[] = ["zh", "en", "ja"];

  // 根据当前 pathname 推断语言（如果不存在则默认 zh）
  const currentLanguage = useMemo(() => {
    const segs = pathname.split("/");
    const first = segs[1];
    return supported.includes(first as Language) ? (first as Language) : "zh";
  }, [pathname]);

  const handleLanguageChange = (lang: Language) => {
    // 将 locale 插入或替换到路径的第一个 segment
    const segs = pathname.split("/");
    if (supported.includes(segs[1] as Language)) {
      segs[1] = lang;
    } else {
      segs.splice(1, 0, lang);
    }
    const newPath = segs.join("/") || "/";
    // Store in both keys for compatibility
    localStorage.setItem("language", lang);
    localStorage.setItem("preferred_locale", lang);
    router.push(newPath);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9">
          <Globe className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => handleLanguageChange("zh")}>
          <span className="mr-2">中文</span>
          {currentLanguage === "zh" && <Check className="h-4 w-4" />}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleLanguageChange("en")}>
          <span className="mr-2">English</span>
          {currentLanguage === "en" && <Check className="h-4 w-4" />}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleLanguageChange("ja")}>
          <span className="mr-2">日本語</span>
          {currentLanguage === "ja" && <Check className="h-4 w-4" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
